module.exports = __webpack_public_path__ + "media/components/landing_pages/smart_storage_v2/images/local_shipping_icon-a3267f3a0a9adfdfb4e93803d5ee42a7.svg";